import api from "../service/api";
import { responseBuild } from "./utils";
import { Buffer } from "buffer";

const service = api;

export const postLoginCandidato = async (correo, password) => {
  const encode = Buffer.from(JSON.stringify({ user: correo, password })).toString("base64");  
  const request = await service.post(`/auth/mireclu`, { data: encode }).then(
    response => {
      if(response.status !== 200 && response.status !== 204){
      return null;
    }
    else if(response.status === 200) {
      localStorage.setItem('sesion-mireclu',JSON.stringify(response.data))
      return response.data;
    }
  }
  );
  if (request) {
    return request;
  }
  return {};
};

export const actualizarPasswordCandidato = async (idCandidato, password) => {
  let request = await service
    .put(`/candidatos/requiere-cambio-password/${idCandidato}`, {
      password: Buffer.from(password).toString("base64"),
    })
    .then(responseBuild);
  if (request) {
    return request;
  }
  return {};
};
